import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { useMemo } from "react";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import { useMaquinasEquipItensControleViewModel } from "../../viewModels/maquinas_equip_itens_controle_view_model";
import { StatisticsPanel } from "./components/statistics_panel";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GetAllControledePatrimonioInspecaoDaoModel } from "../../../domain/models/ControledePatrimonioInspecao";
import { GenerateMaquinasEquipItensControleColumnDefs } from "./columns";
import { ModalCreateMaquinasequipControle } from "./components/modal_create";
import { CopyInspecaoMaquinaEquipModal } from "./components/copy_inspecao_maquina_equip_modal";
import { InspecaoMaquinaEquipGraficoModal } from "./components/inspecao_maquina_equip_grafico_modal";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import RefreshButton from "../../../../../common/components/refresh_button";

export const MaquinasEquipItensControle = () => {
  const viewModel = useMaquinasEquipItensControleViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateMaquinasEquipItensControleColumnDefs({
      status: viewModel.controleCentroCusto ? viewModel.controleCentroCusto.status : null,
      onActionEditar: viewModel.handleInspecaoMaquinaEquipOpenState,
      onActionDeletar: viewModel.handleInspecaoMaquinaEquipDeleteOpenState,
      onActionCopy: viewModel.handleCopyInspecaoMaquinaEquipModalOpenState,
      onEnterInspecaoObra: viewModel.handleInspecaoMaquinaEquipEnter,
    });
  }, [
    viewModel.controleCentroCusto,
    viewModel.handleInspecaoMaquinaEquipOpenState,
    viewModel.handleInspecaoMaquinaEquipDeleteOpenState,
    viewModel.handleCopyInspecaoMaquinaEquipModalOpenState,
    viewModel.handleInspecaoMaquinaEquipEnter,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[9rem]">
                <PrimaryButton buttonColor="secondary" onMouseDown={e => {
                  viewModel.handleInspecaoMaquinaEquipGraficoModalOpenState(true);
                  e.preventDefault();
                }}>
                  Gráfico Resumo
                </PrimaryButton>
              </div>
              {
                viewModel.controleCentroCusto && viewModel.controleCentroCusto.status === 0 &&
                <div className="w-[7.5rem]">
                  <PrimaryButton
                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                    onClick={() => viewModel.handleInspecaoMaquinaEquipOpenState(null, true)}>
                    Novo Item
                  </PrimaryButton>
                </div>
              }
              <BackButton onClick={() => viewModel.handleBack()} />
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-6 flex-col py-10 px-4 mb-8">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Controle de Patrimônio
          </Link>
          <Link underline="hover" color="inherit" component={"span"}>
            <LinkTo to="/MaquinasEquip_controle">Controle</LinkTo>
          </Link>
          <Typography className="text-primary-green">Inspeção de Máquinas e Equipamentos</Typography>
        </Breadcrumbs>
        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Inspeção de Máquinas e Equipamentos</h1>
          <RefreshButton onClick={() => viewModel.handleReload()} />
        </div>

        <StatisticsPanel
          controleCentroCusto={viewModel.controleCentroCusto}
          estatisticasControle={viewModel.estatisticasControle}
          statusControle={viewModel.controleCentroCusto ? viewModel.controleCentroCusto.status : null}
          metaControle={viewModel.metaControle}
          onChangeStatus={viewModel.handleControleCentroCustoStatusChange}
          onChangeMeta={viewModel.handleControleCentroCustoMetaChange}
          onChangeBlur={viewModel.handleControleCentroCustoBlur}
        />

        <Header
          maquinaEquip={viewModel.filters.maquinaEquip}
          maquinaEquipDropDown={viewModel.maquinaEquipDropDown}
          onMaquinaEquipChange={viewModel.handleMaquinaEquipChange}
          onClear={viewModel.handleClear}
          handleDataEntradaRangeChange={viewModel.handleDataReceberRangeChange}
          dataEntradaDe={viewModel.filters.dataEntradaDe}
          dataEntradaAte={viewModel.filters.dataEntradaAte}
          codigo={viewModel.filters.codigo}
          handleCodigo={viewModel.handleCodigoChange}
        />

        <StyledDataGrid
          tableName="maquinas_equip_itens_controle"
          disableColumnMenu={false}
          showToolbar={true}
          disableRowSelectionOnClick={true}
          getRowId={(row: GetAllControledePatrimonioInspecaoDaoModel) => row.idInspecaoMaquinaEquip ?? ""}
          columns={columnsDefinition}
          loading={viewModel.loading}
          checkboxSelection={false}
          rows={viewModel.inspecoesMaquinaEquip}
          rowCount={viewModel.inspecoesMaquinaEquip.length}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationMode="server"
          paginationModel={{
            page: viewModel.pagination.page,
            pageSize: viewModel.pagination.rowsPerPage,
          }}
          autoHeight={true}
          textSize="medio"
          getRowHeight={() => "auto"}
        />
        <TablePagination
          component="div"
          count={viewModel.pagination.totalItems}
          page={viewModel.pagination.page - 1}
          onPageChange={(_, p) => viewModel.handlePageChange(p)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={viewModel.pagination.rowsPerPage}
          onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
        />

      </div>

      <ModalCreateMaquinasequipControle
        open={viewModel.inspecaoMaquinaEquipModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedInspecaoMaquinaEquip={viewModel.selectedInspecaoMaquinaEquip}
        maquinaEquipDropDown={viewModel.maquinaEquipDropDown}
        onClose={() => viewModel.handleInspecaoMaquinaEquipOpenState(null, false)}
        onSubmit={viewModel.handleInspecaoMaquinaEquipSubmit}
      />

      <InspecaoMaquinaEquipGraficoModal
        open={viewModel.inspecaoMaquinaEquipGraficoModal}
        loading={viewModel.loading}
        metaAprovacao={viewModel.controleCentroCusto ? viewModel.controleCentroCusto.metaAprovacao : 0}
        estatisticasControle={viewModel.estatisticasControle}
        onClose={() => viewModel.handleInspecaoMaquinaEquipGraficoModalOpenState(false)}
      />

      <CopyInspecaoMaquinaEquipModal
        open={viewModel.copyInspecaoMaquinaEquipModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={() => viewModel.handleCopyInspecaoMaquinaEquipModalOpenState(null, false)}
        onSubmit={viewModel.handleCopyInspecaoMaquinaEquipSubmit}
      />

      <DeleteDialog
        open={viewModel.inspecaoMaquinaEquipDeleteModal}
        title={`Você realmente deseja excluir este item?`}
        onClose={() => viewModel.handleInspecaoMaquinaEquipDeleteOpenState(null, false)}
        onDelete={viewModel.handleInspecaoMaquinaEquipDeleteSubmit}
      />
    </>
  );
};
